module.exports = __webpack_public_path__ + "static/edit-file-ajax-products-by-cateegory-sorting-tabs-6bc2b53712024916362505c59c044b89.png";